module.exports = __webpack_public_path__ + "img/28.811806fd.jpg";